import { Types } from '@store/types';

const initialState = { response: {}, filterField: {} };

const SampleViewReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_SAMPLE_BY_ID:
			return { ...state, response: { ...action.payload } };
		case Types.SET_SAMPLE_VIEW_FILTER_DATA:
			return { ...state, filterField: { ...action.payload } };
		default:
			return state;
	}
};

export default SampleViewReducer;
